import React from 'react'
import { PieChart, Pie, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";

const PieCharts = ({ data, nameKey, title, innerRadius, colors }) => {
    // const COLORS = ["#8884d8", "#ff7f7f"];
    return (
        <div className='w-full h-full flex flex-col'>
            <h1 className='font-semibold mb-8 ml-2'>{title}</h1>
            <div style={{ width: "100%", height: 300 }} className="flex-1 min-h-0">
                <ResponsiveContainer>
                    <PieChart >
                        <Pie
                            data={data}
                            dataKey="percentage"
                            nameKey={nameKey}
                            outerRadius={90}
                            innerRadius={innerRadius}
                            label={({ value, x, y, fill }) => (
                                <text
                                    x={x}
                                    y={y}
                                    fill={fill}
                                    fontSize={10}   // reduce label size here
                                >
                                    {value}%
                                </text>
                            )}
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={colors[index % colors.length]}
                                />
                            ))}
                        </Pie>

                        <Tooltip />
                        <Legend wrapperStyle={{ fontSize: "10px", paddingTop: "10px" }} />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default PieCharts
